import React, { Component } from "react";
import {
  Col,
  Container,
  Row
} from "reactstrap";

//import icon
import FeatherIcon from "feather-icons-react";

import { Link } from "react-router-dom";

// feature Image
import Img1 from "../assets/images/project/img-1.png";
import Img2 from "../assets/images/project/img-2.png";
import Img3 from "../assets/images/project/img-3.png";
import Img4 from "../assets/images/project/img-4.png";
import Img5 from "../assets/images/project/img-5.png";
import Img6 from "../assets/images/project/img-6.png";

export default class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [
        {
          id: 1,
          img: Img1,
          title: 'Efesiensi & produktivitas dalam pelayanan administrasi desa.',
        },
        {
          id: 2,
          img: Img2,
          title: 'Penyebaran Informasi & penerimaan informasi update dan ter-up to date',
        },
        {
          id: 3,
          img: Img3,
          title: 'Pelaporan masalah desa lebih cepat',
        },
        {
          id: 4,
          img: Img4,
          title: 'Pengelolaan surat yang mudah, penyimpanan data yang aman, dan perssetujuan surat pengajuan yang cepat',
        },
        {
          id: 5,
          img: Img5,
          title: 'Dapat memantau perkembangan desa secara real time',
        },
        {
          id: 6,
          img: Img6,
          title: 'Dapat diakses dimanapun & kapan pun',
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-light" id="project" data-aos="fade-up" data-aos-duration="750" data-aos-easing="ease-out-back">
          <Container>
            <Row className="justify-content-center">
              <div className="col-lg-7">
                <div className="text-center mb-5">
                  <h2 className="">Manfaat Desapedia</h2>
                  {/* <p className="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
                  {/* Lorem ipsum dolor sit amet</p> */}
                </div>
              </div>
            </Row>
            <Row>
              {/* Render Footer Link */}
              {this.state.projects.map((item, key) => (
                <Col lg={4} md={6} key={key}>
                  <div className="project-box mb-4">
                    <div className="color-cover position-relative">
                      <img 
                      src={item.img} 
                      alt="" className="img-fluid d-block mx-auto shadow" />
                      <div className="project-overlay">
                        <div className="project-content">
                          {/* <Link to="#">
                            <div className="project-icon">
                              <i>
                                <FeatherIcon icon="eye" />
                              </i>
                            </div>
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="p-3">
                      <p className=" mb-1">
                        <Link to="#" style={{color:'black'}}>{item.title}</Link>
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
